import CrewsPage from './crews';

export default CrewsPage;
